/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_SUPPLIER_URL, COMMON_HEADER_CONFIG} from "../config";

class SellerService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListSeller = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SUPPLIER_URL}/seller`,
        params: {
          size: 100,
          page: 1,
          lang: "vi",
          sort: "created_at desc",
          ...params
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneSeller = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SUPPLIER_URL}/seller/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateSeller = (data) =>
    new Promise((resolve, reject) => {
      // const dataUpdate = JSON.stringify(data);
      const config = {
        method: "put",
        url: `${API_SUPPLIER_URL}/seller/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const sellerService = new SellerService();

export default sellerService;
